(function () {

	const gSelector = {
		html: document.querySelector('html'),
		body: document.querySelector('body'),
		header: document.querySelector('.l-header'),
		floatMenu: document.querySelector('.l-float-menu'),
		headerOpenClass: 'is-navi-open',
		headerVariableClass: 'is-header-show',
	};
	const breakPoint = {
		a: 768,
		b: 767
	};
	const windowSize = {
		width: window.innerWidth,
		height: window.innerHeight
	};


	// ユーザーエージェント関連
	const deviceCategory = {
		mobile: "ua_mobile",
		tablet: "ua_tablet",
		pc: "ua_pc"
	};
	const deviceParser = () => {
		const ua = navigator.userAgent;
		if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
			// スマホ
			gSelector.html.classList.add('ua_mobile');
			return deviceCategory.mobile;
		} else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
			// タブレット
			gSelector.html.classList.add('ua_tablet');
			document.querySelector('meta[name=viewport]').setAttribute('content', 'width=1300,user-scalable=yes,maximum-scale=2.0');
			return deviceCategory.tablet;
		} else {
			// PC
			gSelector.html.classList.add('ua_pc');
			return deviceCategory.pc;
		}
	};
	const device = deviceParser();
	// example
	// if(device == deviceCategory.mobile) console.log("mobile");


	// ヘッダー・フッター
	const headerMenu = () => {
		gSelector.body.classList.toggle(gSelector.headerOpenClass);
	}
	(function () {
		// メニュー開閉
		const humberger = document.querySelector('.l-header__humberger');
		if (humberger) {
			humberger.addEventListener('click', function () {
				headerMenu();
			}, false);
		}
		window.addEventListener('scroll', () => {
			const headerVariable = document.querySelector('.header-variable');
			let windowScrollY = window.pageYOffset;
			// ヘッダー途中から表示
			if(headerVariable) {
				const headerVariablePos = 550;
				windowScrollY > headerVariablePos ? gSelector.body.classList.add(gSelector.headerVariableClass) : gSelector.body.classList.remove(gSelector.headerVariableClass);
			}
			// フロートメニューは途中から表示
			if (gSelector.floatMenu) {
				const floatActivePos = 300;
				windowScrollY > floatActivePos ? gSelector.floatMenu.classList.add('is-active') : gSelector.floatMenu.classList.remove('is-active');
			}
		});
	})();


	// アンカーリンク
	(function () {
		const scrollTrigger = document.querySelectorAll('a[href^="#"]');
		for (let i = 0; i < scrollTrigger.length; i++) {
			scrollTrigger[i].addEventListener('click', (e) => {
				e.preventDefault();
				let href = scrollTrigger[i].getAttribute('href');
				let targetElement = document.getElementById(href.replace('#', ''));
				anchorScroll(targetElement);
			});
		}
		// ページをまたぐアンカーリンク
		const anchorTrigger = document.querySelectorAll('a[data-anchor]');
		for (let i = 0; i < anchorTrigger.length; i++) {
			anchorTrigger[i].addEventListener('click', (e) => {
				e.preventDefault();
				const data = anchorTrigger[i].getAttribute('data-anchor');
				const anchor = data.split('?');
				const anchorPath = anchor[0];
				const anchorId = anchor[1].split('=')[1];
				const anchorTarget = document.getElementById(anchorId);
				if (anchorPath == location.pathname) {
					// ページが同じならスクロール
					anchorScroll(anchorTarget);
					// URLに挿入する
					history.replaceState('', '', data);
					// メニュー閉じる
					headerMenu();
				} else {
					// ページが異なるなら該当ページへ移動させる
					location.href = data;
				}
			});
		}
		// アクセス時にanchorが存在したらスクロールさせる
		window.addEventListener('load', () => {
			if (document.URL.match(/anchor/)) {
				const data = location.href;
				const anchor = data.split('?');
				const anchorId = anchor[1].split('=')[1];
				const anchorTarget = document.getElementById(anchorId);
				const gap = gSelector.header.offsetHeight;
				anchorScroll(anchorTarget);
			}
		});
		// アンカー共通処理
		const anchorScroll = (t) => {
			const rect = t.getBoundingClientRect().top;
			const offset = window.pageYOffset;
			const gap = windowSize.width >= breakPoint.a ? 65 : gSelector.header.offsetHeight;
			const target = rect + offset - gap;
			window.scrollTo({
				top: target,
				behavior: 'smooth',
			});
		}
	})();


	// 要素が見えたらクラス追加
	document.addEventListener('DOMContentLoaded', function () {
		//監視したい要素を取得
		const target = document.querySelectorAll('.js-view-observer')
		const targetArray = Array.prototype.slice.call(target);
		//オプション設定
		const options = {
			root: null,
			rootMargin: "-30% 0px",
			threshold: 0
		};
		//Intersection Observerを呼ぶ
		const observer = new IntersectionObserver(callback, options)
		targetArray.forEach((tgt) => {
			observer.observe(tgt)
		});
		//要素が交差したときの処理
		function callback(entries) {
			entries.forEach(function (entry, i) {
				const target = entry.target;
				if (entry.isIntersecting && !target.classList.contains('is-active')) {
					const delay = i * 100
					setTimeout(function () {
						target.classList.add('is-active');
					}, delay);
				}
			});
		};
	});


	// トグルメニュー
	(function () {
		const toggleHead = document.querySelectorAll('.m-toggle-box__head');
		Array.from(toggleHead).forEach(function (e) {
			e.addEventListener('click', () => {
				e.parentNode.classList.toggle('is-active');
			});
		});
	})();


	const accordionAction = function (className) {
		const title = document.querySelectorAll(className);
		for (let i = 0; i < title.length; i++) {
			let titleEach = title[i];
			let content = titleEach.nextElementSibling;
			titleEach.addEventListener('click', () => {
				titleEach.classList.toggle('is-active');
				content.classList.toggle('is-open');
			});
		}
	}

	const aboutPageAccordion = (function () {
		const accordion = function () {
			if (window.innerWidth <= 768) {
				accordionAction('.js-accordion-title') 
			}
		}
		// アコーディオン

		document.addEventListener("DOMContentLoaded", () => {
			accordion();
		});
		document.addEventListener("resize", () => {
			accordion();
		});

	})();

	const recruitPageAccordion = (function () {

		document.addEventListener("DOMContentLoaded", () => {
			accordionAction('.js-recruit-accordion-title')
		});
		document.addEventListener("resize", () => {
			accordionAction('.js-recruit-accordion-title')
		});

	})();

	const photoModal = (() => {
		window.addEventListener("DOMContentLoaded", () => {
			// モーダルを取得
			const modal = document.getElementById("modal");
			// モーダルを表示するボタンを全て取得
			const openModalBtns = document.querySelectorAll(".js-open-modal");
			// モーダルを閉じるボタンを全て取得
			const closeModalBtns = document.querySelectorAll(".js-close-modal");
			// Swiperの設定
			const swiper = new Swiper(".modal__slider", {
				loop: true,
				slideToClickedSlide: true,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				spaceBetween: 30,
				breakpoints: {
					// スライドの表示枚数：500px以上の場合
					768: {
						allowTouchMove: false,
					}
				}
			});
			// モーダルを表示するボタンをクリックしたとき
			openModalBtns.forEach((openModalBtn) => {
				openModalBtn.addEventListener("click", () => {
					// data-slide-indexに設定したスライド番号を取得
					const modalIndex = openModalBtn.dataset.slideIndex;
					swiper.slideTo(modalIndex);
					modal.classList.add("is-active");
					document.body.style.overflow = 'hidden';
					setTimeout(() => {
						document.querySelector('#photo-modal .swiper').classList.add('is-active')
					}, 300);
					// 位置調整
					if(window.innerWidth >= breakPoint.a) {
						let windowScrollY = window.pageYOffset;
						modal.style.top = windowScrollY + 'px';
					} else {
						modal.style.top = "";
					}
				});
			});
			// モーダルを閉じるボタンをクリックしたとき
			closeModalBtns.forEach((closeModalBtn) => {
				closeModalBtn.addEventListener("click", () => {
					modal.classList.remove("is-active");
					document.body.style.overflow = '';
					document.querySelector('#photo-modal .swiper').classList.remove('is-active')
				});
			});
		});
	})();

	const recruitSwiper = new Swiper(".js-recruit-swiper", {
		// ページネーションが必要なら追加
		pagination: {
			el: ".swiper-pagination",
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev"
		}
	});

	// selectでURL切り替え
	const selectChangeUrl = (() => {
		const select = document.querySelectorAll('.js-select-url');
		select.forEach((tgt) => {
			tgt.addEventListener('change', () => {
				document.location.href = tgt.options[tgt.selectedIndex].value;
			});
		});
	})();

})();








